import { IdCodeLibelle } from '../../id-code-libelle.abstract.model';

export class RefMvtDistillationVCI extends IdCodeLibelle {}
